import { render, staticRenderFns } from "./AccountDeactivate.vue?vue&type=template&id=2cc1a080"
import script from "./AccountDeactivate.vue?vue&type=script&lang=js"
export * from "./AccountDeactivate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports